import React from 'react';
import HelpResultCard from "../help/HelpResultCard";
import openLibraryResource from "../shared/utilities/openLibraryResource";
import Image from "../shared/Image";
import LabelHiddenInWideView from "../shared/LabelHiddenInWideView";
import HelpResultCardContainer from "../help/HelpResultCardContainer";
import {AuthContext} from "../../authContext";
import lockIcon from "../../assets/images/icons/lock.svg";
import PrivateLibraryBadge from "../shared/PrivateLibraryBadge";

class LibraryItemCollection extends React.Component {
  static contextType = AuthContext;
  render() {
    return (
      <React.Fragment>
        <p>
          <strong>
            1 - Click a city item once to download it<br/>
            2 - Click again in your CityCAD model to place it
          </strong>
        </p>
        <p>
          Before placing a city item, you can rotate it by holding down the control key and scrolling up or down.
        </p>
        <HelpResultCardContainer>
          {
            this.props.items.map(item => {
              return (
                <HelpResultCard
                  paddingNarrow={`0px`}
                  key={item.id}
                  onClick={() => openLibraryResource(item.id, item.name, item.fileReference)}
                >
                  <div>
                    <Image
                      title={item.description !== null ? item.description : ""}
                      maxWidth={`100px`}
                      src={`https://www.holisticcity.co.uk/images/components/${item.image}`}
                      alt={`Item image`}
                    />
                  </div>
                  <div style={{padding: "0px 10px", maxWidth: "180px"}}>
                    {item.name}<br />
                    {/*{this.context.userDetails.userID === Number(item.userID) && <PrivateLibraryBadge />}<br/>*/}
                    <LabelHiddenInWideView>
                      {item.description}
                    </LabelHiddenInWideView>
                  </div>
                </HelpResultCard>
              )
            })
          }
        </HelpResultCardContainer>
      </React.Fragment>
    )
  }
}

export default LibraryItemCollection;